<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    width="900px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :disabled="disabled"
      :amzAppCode="amzAppCode"
      :amzAppAccountCode="amzAppAccountCode"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    amzAppCode: { type: String, default: '' },
    amzAppAccountCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('dialog_title_editAccount') || '编辑应用账号',
        add: this.$l('dialog_title_addAccount') || '新增应用账号',
        detail: this.$l('dialog_title_detailAccount') || '应用账号详情',
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
